import { Link } from "react-router-dom";
import PaymentSuccessLoader from "./Components/payment-success-loader";

const PaymentSuccess = () => {
  return (
    <div className="mx-auto p-2">
      <div className="rounded-xl max-w-[800px] border border-sky-500 shadow-md shadow-slate-400 py-12 px-6 bg-sky-100">
        <div>
          <div className="mb-4">
            <PaymentSuccessLoader />
          </div>
          <h1 className="text-center text-xl font-semibold text-sky-500 mt-4">
            Thank you for your payment!
          </h1>
          <h1 className="text-center text-lg font-semibold text-sky-500 ">
            Your Registration for the Training has been successfully completed.
          </h1>
        </div>
        <div className="text-sm text-sky-400 my-4 text-center">
          <h1>Best Regards,</h1>
          <h1>National Healthcare & Wellness Mission</h1>
          <h1>Contact Number: +913614516663, +919707076232, +919707998887</h1>
          <h1>Email: nhwm.info@gmail.com</h1>
        </div>
        <div className="flex justify-center items-center">
          <Link to="https://nhwm.in" className="mt-8 w-[250px]">
            <div className="w-[250px] px-3 py-2 rounded-md shadow-md text-center hover:shadow-slate-400 bg-sky-500 text-white text-lg font-semibold hover:bg-sky-400 border border-sky-600">
              Go to Home
            </div>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccess;
